module.exports = __webpack_public_path__ + "static/jumping-92b242d0e911fcc47291dad925a1b9a2.jpg";